var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 512,
    viewBox: "0 0 448 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 10.7 37.3 0 24 0C10.7 0 0 10.7 0 24V64V350.5V400V488C0 501.3 10.7 512 24 512C37.3 512 48 501.3 48 488V388L128.3 367.9C169.4 357.6 212.9 362.4 250.8 381.3C295 403.4 346.3 406.1 392.5 388.7L427.2 375.7C439.7 371 448 359.1 448 345.7V66.1C448 43.1 423.8 28.1 403.2 38.4L393.6 43.2C347.3 66.4 292.8 66.4 246.5 43.2C211.4 25.6 171.1 21.2 133 30.7L48 52V24ZM48 101.5L144.6 77.3C171.6 70.6 200.1 73.7 225 86.1C279.9 113.5 343.7 115.8 400 92.9V334.7L375.6 343.8C341.9 356.4 304.4 354.5 272.2 338.4C224 314.3 168.9 308.3 116.6 321.3L48 338.5V101.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.3fa07a7ced027cb3ff9ca287a8cbc045.svg";
export { ForwardRef as ReactComponent };